export default __webpack_public_path__ + "static/media/17-cn.9505fb3b.webp";